import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";

import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RefreshIcon from "@mui/icons-material/Refresh";
import request from "../../../Helpers/API";
import { FormatMoney } from "../../../Helpers/FormatNumber";

export const Operacionestasa0 = () => {
  const history = useHistory();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const [openModal, setOpenModal] = useState(false);

  const [data, setData] = useState([]);

  useEffect(() => {
    onActualizar();
  }, []);
  const onActualizar = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`OperacionesNoEncontradasEquip/ListadoOperaciones_tasa0`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setData(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
      });
  };
  const totalOperaciones = data.length;
  return (
    <PlantillaScreen
      titulo={"OPERACIONES CON TASA 0 REGISTRADA"}
      className_main={1}
      className={"operaciones-no-encontradas-main-screen"}
    >
      <LoaderScreen loader={loader} />
      <div className="operaciones-no-encontradas-actions">
        <div
          className="operaciones-no-encontradas-actions-regresar"
          onClick={() => history.goBack()}
        >
          <ArrowBackIcon /> Regresar
        </div>

        <div
          className="operaciones-no-encontradas-actions-actualizar"
          onClick={() => onActualizar()}
        >
          <RefreshIcon /> Actualizar
        </div>
        {/* <FiltroPlantillasKarbot onExecute={onExecute} /> */}
      </div>
      <div className="operaciones-no-encontradas-numero-clientes">
        {`Se encontraron ${totalOperaciones} operaciones`}
      </div>
      {/* {data === undefined || data === null || data.length === 0 ? (
            <div></div>
        ) : ( */}
      <div className="operaciones-no-encontradas-table scroll-4">
        <table cellPadding={0} cellSpacing={0}>
          <thead>
            <tr>
              <th>
                <div>Folio</div>
              </th>
              <th>
                <div>Sucursal</div>
              </th>
              <th>
                <div>ID Cliente</div>
              </th>
              <th>
                <div>Razón Social</div>
              </th>
              <th>
                <div>Documento</div>
              </th>
              <th>
                <div>Fecha</div>
              </th>
              <th>
                <div>Vencimiento</div>
              </th>
              <th>
                <div>Importe</div>
              </th>
              <th>
                <div>Vendedor</div>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr>
                <td>{item.folio}</td>
                <td>{item.sucursal}</td>
                <td>{item.idcliente}</td>
                <td className="ta-left">{item.razon_social}</td>
                <td className="ta-center">{item.documento}</td>
                <td className="ta-center">{item.fecha}</td>
                <td className="ta-center">{item.vencimiento}</td>
                <td  className="ta-right">{FormatMoney(item.importefactura, 0)}</td>
                <td>{item.vendedor}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </PlantillaScreen>
  );
};
